import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler } from 'common/helpers';
import { IRootModel } from 'app/store';
import { statisticsService } from 'entities/Statistics/Statistics.service';

export const statisticsEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getStatistics(role: string) {
    dispatch.statistics.setLoading(true);

    await statisticsService
      .getStatistics(role)
      .then((response) => {
        dispatch.statistics.setStatistics(response);
      })
      .catch(axiosErrorHandler)
      .finally(() => {
        dispatch.statistics.setLoading(false);
      });
  },
});
